import { useEffect } from "react";

import { DataSet } from "vis-data";
import { TimelineItem } from "vis-timeline/standalone";

import { useAppSelector } from "app/hooks";
import { playbackSessionSelectors } from "./store/selectors.session";

const continuousPlaybackWindowTimelineItemId =
    "PlaybackTimelineContinuousPlaybackWindow";

export interface PlaybackTimelineContinuousPlaybackWindowProps {
    timelineItems: React.MutableRefObject<DataSet<TimelineItem, "id">>;
}

export function PlaybackTimelineContinuousPlaybackWindow(
    props: PlaybackTimelineContinuousPlaybackWindowProps,
) {
    const bufferWindow = useAppSelector(
        playbackSessionSelectors.selectBufferWindow,
    );

    useEffect(() => {
        if (!props.timelineItems.current) return;

        if (
            bufferWindow &&
            bufferWindow.startDateTime &&
            bufferWindow.endDateTime
        ) {
            const item: TimelineItem = {
                id: continuousPlaybackWindowTimelineItemId,
                start: bufferWindow.startDateTime,
                end: bufferWindow.endDateTime,
                type: "background",
                editable: false,
                content: "",
            };

            props.timelineItems.current.update(item);
        } else {
            props.timelineItems.current.remove(
                continuousPlaybackWindowTimelineItemId,
            );
        }

        return () => {
            props.timelineItems.current?.remove(
                continuousPlaybackWindowTimelineItemId,
            );
        };
    }, [bufferWindow, props.timelineItems]);

    // in the future create a React based timeline
    return <></>;
}
